module.exports = __webpack_public_path__ + "static/media/logo-small.2bbf6f99.png";